import React from 'react'
import reactCSS from 'reactcss'
import {ChromePicker} from 'react-color'

class ColorPicker extends React.Component {
  state = {
    displayColorPicker: false,
    color: this.props.color
  };
  handleClick = () => {
    this.setState({displayColorPicker: !this.state.displayColorPicker})
  };
  handleClose = () => {
    this.props.handler(this.state.color)
    this.setState({displayColorPicker: false})
  };
  handleChange = (color) => {
    this.setState({color: color.hex})
  };

  componentDidUpdate() {
    if (this.state.color !== this.props.color
        && !this.state.displayColorPicker) {
      this.setState({color: this.props.color})
    }
  }

  render() {

    const styles = reactCSS({
      'default': {
        color: {
          width: '22px',
          height: '22px',
          borderRadius: '2px',
          background: `${ this.state.color }`,
        },
        swatch: {
          padding: '5px',
          background: '#fff',
          borderRadius: '1px',
          boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
          display: 'inline-block',
          cursor: 'pointer',
        },
        popover: {
          position: 'absolute',
          zIndex: '2',
        },
        cover: {
          position: 'fixed',
          top: '0px',
          right: '0px',
          bottom: '0px',
          left: '0px',
        },
      },
    });

    return (
        <div>
          <div className="img input-group width-225">
            <div className="form-control">
              {this.state.color}
            </div>
            <span className="input-group-btn">
                        <div style={styles.swatch} onClick={this.handleClick}>
                            <div style={styles.color}/>
                        </div>
                    </span>
          </div>
          {this.state.displayColorPicker ? <div style={styles.popover}>
            <div style={styles.cover} onClick={this.handleClose}/>
            <ChromePicker color={this.state.color} onChange={this.handleChange}
                          disableAlpha={true}/>
          </div> : null}

        </div>
    )
  }
}

export default ColorPicker